var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.168945 0H46.1689V46H0.168945V0ZM10.1689 17H6.16895V37.3774L10.1689 41V17ZM27.0578 31.7406H33.6503C33.2882 32.6322 32.7764 33.4645 32.1293 34.1978C30.7413 35.7716 28.8267 36.7843 26.7448 37.0466C24.6629 37.3088 22.557 36.802 20.8223 35.6211C19.0876 34.4406 17.8435 32.6674 17.3235 30.6348C16.8035 28.6016 17.0433 26.4491 17.998 24.5806C18.9527 22.712 20.5566 21.2562 22.5086 20.4863C24.4606 19.7168 26.6265 19.6856 28.5996 20.3995C30.5727 21.1134 32.2175 22.523 33.225 24.3636L36.6335 22.4977C35.1714 19.8267 32.7848 17.7813 29.9216 16.7456C27.0583 15.7098 23.9155 15.7545 21.083 16.8717C18.2505 17.9889 15.9231 20.1011 14.5377 22.8128C13.1523 25.5241 12.8043 28.6477 13.5589 31.5977C14.3135 34.5473 16.1188 37.1202 18.636 38.8337C21.1531 40.5468 24.2091 41.2824 27.2301 40.9021C30.2511 40.5215 33.0294 39.0517 35.0435 36.7685C36.9404 34.6178 38.0365 31.8848 38.1577 29.0302L38.1689 28.9629V28.0369H30.6134L27.0578 31.7406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.9a71077e5b35f62bd6aded1ee2ab6cc8.svg";
export { ForwardRef as ReactComponent };